module.exports = __webpack_public_path__ + "static/img/industry.b1bf540.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/industry.png
// module id = JNhd
// module chunks = 9